export const translation = {
  SEARCH_CATALOG: "Suche im Katalog",
  MY_SETUP: "Meine Einstellungen",
  CONTACT_US: "Kontaktieren Sie uns",
  HELP: "Hilfe",
  LOGOUT: "Ausloggen",
  ORDER_FAVORITES: "Favoritenbestellung",
  QUICK_ORDER: "Direktbestellung",
  ORDER_BANDS: "Bänderbestellung",
  CATALOG: "Katalog",
  SAVED_CARTS: "Gespeicherte Warenkörbe",
  MY_CART: "Mein Warenkorb",
  MY_ORDERS: "Meine Bestellungen",
  MY_STATEMENT: "Mein Kontostand",
  WELCOME: "Willkommen",
  LOGIN_ID: "Benutzername",
  ACCOUNT_NUMBER: "Kundennummer",
  ADDRESS: "Adresse",
  PHONE: "Telefon",
  FAX: "Fax",
  PRICE_DISCOUNT: "Preisnachlass",
  SHOW_CUSTOMER_DETAILS: "Kundendetails anzeigen",
  HIDE_CUSTOMER_DETAILS: "Kundendetails ausblenden",
  MY_REWARDS: "Meine Belohnungen", //==> needs to be verified
  PRODUCTS: "Produkte",
  YOUR_PRODUCTS: "Ihre Produkte", //==> needs to be verified
  MANAGE_ACCOUNTS: "Konten verwalten", //==> needs to be verified
  //CATALOG PAGE
  PRODUCTS: "Produkte",
  HOME: "Startseite",
  //Saved Carts
  CART_NUMBER: "Warenkorb-Nummer",
  CART_NAME: "Warenkorb-Name",
  LAST_UPDATED: "Zuletzt aktualisiert",
  TOTAL: "Insgesamt",
  ACTIONS: "Aktionen",
  SAVED_CARTS: "Gespeicherte Warenkörbe",
  CREATE_CART: "Warenkorb erstellen",
  VIEW_CART_DETAILS: "Einzelheiten zum Warenkorb anzeigen",
  SET_AS_CURRENT_CART: "Als aktuellen Warenkorb festlegen",
  RENAME_CART: "Warenkorb umbenennen",
  DELETE_CART: "Warenkorb löschen",
  ACTIVE_CART_MESSAGE: "Dies ist Ihr aktiver Einkaufswagen", // => needs to be verified
  LOCK_CART_MESSAGE: "Dieser Warenkorb ist durch den Benutzernamen gesperrt",
  RENAME: "Umbenennen",
  DELETE: "Löschen",
  CANCEL: "Abbrechen",
  PRIVATE_CART_MESSAGE:
    "Dieser Warenkorb ist nicht öffentlich. Bitte entsperren Sie ihn, damit andere diesen Warenkorb ansehen können.",
  UNLOCK_CART: "Warenkorb entsperren",
  TAKE_OVER_LOCK: "Sperre übernehmen", // => needs to be verified
  LOCK_CART: "Warenkorb sperren",
  CART_NAME: "Warenkorbname", // => needs to be verified
  LOCK_CART_SELF_MESSAGE:
    "Sie haben diesen Warenkorb gesperrt. Niemand sonst kann diesen Warenkorb bearbeiten.",
  CREATE: "Erstellen", //=> needs to be verified
  CUSTOMER_SUPPORT: "Kundenbetreuung", // => needs to be verified
  YOUR_ACCOUNT: "Ihr Konto", //=> needs to be verified
  ITEMS: "Artikel", // => needs to be verified
  //Product Details Page
  OVERVIEW: "Übersicht",
  SPECIFICATIONS: "Spezifikationen",
  DETAILS: "Details",
  VIEW_LEGAL_DISCLAIMER: "Rechtliche Hinweise ansehen",
  PRODUCTS_AVAILABLE: "Verfügbare Produkte",
  THREEM_SITE_REDIRECT_MSG:
    "Klicken Sie hier, um dieses Produkt auf Solventum.com zu sehen", // => needs to be verified
  LEGAL_DISCLAIMER: "Rechtliche Hinweise",
  ENDORSEMENT_MSG:
    "*Solventum-Version dieses Rezepts. Es wird keine Billigung durch den Arzt impliziert.", // => needs to be verified
  SEARCH_RESULTS_FOR: "Ergebnis durchsuchen nach",
  CATALOG_PRODUCT: "Katalog",
  SEARCH_RESULTS: "Ergebnis durchsuchen ...",
  //My Rewards Page (Not needed for germany right now)
  SAVINGS_THIS_YEAR: "Einsparungen in diesem Jahr",
  CURRENT_3M: "Aktuelle Solventum",
  TM: "TM",
  CLARITY: "Klarheit",
  DISCOUNT_STATUS: "Aligner verdienter Rabattstatus",
  CLARITY_ALIGNERS_CASES: "Clarity Aligners Hüllen",
  OTHER_PRODUCT_PURCHASES: "Sonstige Produktkäufe",
  SPEND: "Ausgeben",
  IN_PRODUCT_PURCHASES: "beim Produktkauf",
  ADD: "Hinzufügen",
  OR: "ODER",
  CLARITY_ALIGNERS_ORDERS: "Clarity Aligners Bestellungen",
  DATE: "Datum",
  INVOICE_NUMBER: "Rechnungsnummer",
  ORDER_NUMBER: "Bestellnummer",
  QUALIFYING_CASES: "Qualifizierende Fälle",
  QUALIFYING_PURCHASES: "Qualifizierende Käufe",
  OTHER_ORTHODONTIC_PURCHASES: "Andere kieferorthopädische Einkäufe",
  FAQS: "Häufig gestellte Fragen (FAQs)",
  //MAC BOB
  BUYING_FOR: "Kaufen für",
  BUY_ON_BEHALF: "Kauf im Auftrag von",
  RETURN_TO_HEADQUARTERS: "Zurück an die Zentrale ",

  //Shopping cart
  SHOPPING_CART: "Einkaufswagen",
  PRINT_QUOTE: "Angebot drucken",
  CART_LOCKED: "Warenkorb gesperrt",
  CART_UNLOCKED: "Warenkorb freigeschaltet",
  SELECT_ITEMS: "Wählen Sie die Artikel aus, die Sie verwenden möchten",
  APPLY_A_DISCOUNT: "Wenden Sie einen Rabatt an",
  APPLY_DISCOUNT: "Rabatt anwenden",
  DELETE: "Löschen",
  ESTIMATED_SUBTOTAL: "Geschätzte Zwischensumme",
  ITEMS: "Artikel",
  SHIPPING_MESSAGE:
    "Versand und Steuern werden nach Ihrer Bestellung geschätzt",
  PROCEED_TO_CHECKOUT: "Zur Kasse gehen",
  NET_PRICE_DESCRIPTION:
    "Ihr Nettopreis beinhaltet Ihr personalisiertes Preisprogramm",
  TYPE: "Art",
  SIZE: "Größ",
  QUANTITY: "Menge",
  EDIT_ORDER: "Bestellung bearbeiten",
  COMMENTS: "Kommentare",
  CART_EMPTY_MESSAGE: "Ihr Warenkorb ist leer!",
  SHOP_YOUR_FAVORITES: "Shoppen Sie Ihre Favoriten",
  SHOP_ORDER_HISTORY: "Bestellhistorie im Shop",
  LOADING_YOUR_CART: "Ihr Warenkorb wird geladen...",
  THE_ORDER_IS_LOCKED:
    "Die Bestellung ist gesperrt. Um die Bestellung zu bearbeiten, wenden Sie sich an Ihren Solventum-Außendienstmitarbeiter, der auf der Seite „Kontakt“ aufgeführt ist.",
  THE_ORDER_IS_UNLOCK:
    "Die Bestellung ist entsperrt. Klicken Sie auf „Sperren“, um die Bestellung zu bearbeiten.",
  TO_APPLY_A_DISCOUNT:
    "Um einen Rabatt anzuwenden, wählen Sie ein oder mehrere Produkte und einen Rabattcode aus.",

  //Checkout page
  CHECKOUT: "Kasse",
  PLACE_ORDER: "Bestellung aufgeben",
  SHIPPING_CONTACT_INFO_HEADER: "Versand- und Kontaktinformationen",
  PLACING_ORDER_HEADER: "Wer gibt diese Bestellung auf?",
  SHIPPING_ADDRESS: "Lieferanschrift",
  PRIMARY_CONTACT_INFO_HEADER: "Hauptkontaktinformationen",
  CONFIRMATION_HEADER:
    "Möchten Sie jemand anderem eine Bestätigungs-E-Mail senden?",
  RECIPIENT_EMAIL_HEADER: "Empfänger E-Mail",
  ENTER_EMAIL: "Email eingeben",
  ADD_RECIPIENT: "Empfänger hinzufügen",
  ADD_RECIPIENT_EMAIL_MESSAGE:
    "Bitte fügen Sie die E-Mail-Adresse des Empfängers hinzu",
  VALID_EMAIL_ADDRESS_MESSAGE: "Bitte geben Sie eine gültige Email Adresse an",
  PAYMENT_INFO_HEADER: "Zahlungsinformationen",
  CARD: "Karte",
  ACH: "ACH",
  BILL_MY_ACCOUNT: "Rechnung auf mein Konto stellen",
  YOUR_CARDS: "Ihre Karten",
  EXPIRES: "Läuft ab",
  NO_CARD_MESSAGE: "Sie haben derzeit keine Karten hinterlegt.",
  ADD_CARD_MESSAGE:
    "Fügen Sie eine Karte hinzu oder wählen Sie eine andere Zahlungsmethode aus, um Ihre Bestellung aufzugeben.",
  ADD_NEW_CARD: "Neue Karte hinzufügen",
  ADD_CARD: "Karte hinzufügen",
  ACH_PAYMENT_HEADER: "Ihre ACH-Zahlungsoptionen",
  NO_ACH_MESSAGE: "Sie haben derzeit keine ACH-Zahlungsmethoden eingerichtet.",
  ADD_ACH_MESSAGE:
    "Fügen Sie ein ACH-Konto hinzu oder wählen Sie eine andere Zahlungsmethode, um Ihre Bestellung aufzugeben.",
  ADD_NEW_ACH: "Neues ACH hinzufügen",
  ADD_ACH: "ACH hinzufügen",
  PAYMENT_TERMS: "Zahlungsbedingungen",
  DEFAULT_PAYMENT_METHOD: "Standardzahlungsmethode",
  BILLING_ADDRESS: "Rechnungsadresse",
  NO_BILL_MY_ACCOUNT_MESSAGE:
    "Sie sind derzeit nicht für die Kontoabrechnung eingerichtet.",
  CUSTOMER_SERVICE_MESSAGE:
    "Kontaktieren Sie den Kundenservice oder wählen Sie eine andere Zahlungsmethode, um Ihre Bestellung aufzugeben.",
  REVIEW_PURCHASE_HEADER: "Überprüfen Sie den Kauf",
  PO_NUMBER_LABEL: "Haben Sie eine Bestellnummer für diese Bestellung?",
  SPECIAL_INSTRUCTIONS_LABEL:
    "Haben Sie spezielle Anweisungen für diese Bestellung?",
  CHARACTER_LIMIT_MESSAGE: "Bitte geben Sie bis zu 255 Zeichen ein.",
  CHARACTERS_LEFT: "Zeichen übrig:",
  REVIEW_ITEMS_MESSAGE:
    "Überprüfen Sie die Artikel noch einmal, bevor Sie Ihre Bestellung aufgeben.",
  UNIT_PRICE: "Einzelpreis",
  LIST_PRICE: "Listenpreis",
  LIST_UNIT_PRICE: "Listenpreis",
  NET_UNIT_PRICE: "Nettoeinzelpreis",
  NET_PRICE: "Nettopreis",
  TOTAL_PRICE: "Gesamtstückpreis",
  CUSTOM_BANDS_HEADER: "Individuell geschweißte Bänder (Rezeptbänder)",
  EDIT_ITEMS_MESSAGE: "Artikel im Warenkorb bearbeiten",
  EMAIL_VALIDATION_MESSAGE:
    "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihre Bestellung aufzugeben.",
  PAYMENT_VALIDATION_MESSAGE:
    "Bitte wählen Sie die Zahlungsmethode aus, um Ihre Bestellung aufzugeben.",
  PAYMENT_METHOD_NOT_AVAILABLE_MESSAGE:
    "Diese Zahlungsmethode ist für dieses Konto nicht verfügbar. Wählen Sie eine andere Zahlungsmethode oder kontaktieren Sie den Kundenservice.",
  PAYMENT_SETUP_INIT_FAILED_MESSAGE:
    "Die Zahlungseinrichtung für dieses Konto konnte nicht initialisiert werden. Wählen Sie eine andere Zahlungsmethode oder kontaktieren Sie den Kundenservice.",
  ENTER_PO_NUMBER: "Geben Sie die Bestellnummer ein",
  DESCRIBE_YOUR_REQUEST: "Beschreiben Sie hier Ihr Anliegen...",
  PREPARING_YOUR_ORDER: "Bereiten Sie Ihre Bestellung vor...",
  RESTORE_DEFAULT_RECIPIENT: "Standardempfaenger wiederherstellen",
};
